<template>
    <div class="" id="SchoolClubRegistration">

        <div class="success-block" v-if="registered">{{ i18n.registracia_skolskeho_klubu_prebehla_uspesne }}</div>

        <div class="warning-block" v-if="validationErrors && !registered">{{ i18n.niektore_polia_ste_nevyplnili_spravne_skontrolujte_ich_a_pokuste_sa_registrovat_znovu }}
        </div>

        <div class="">
            <div class="" v-if="!registered">
                <div class="columns is-multiline">
                    <div class="column is-half">
                        <div class="form-header">
                            <div class="form-header-caption">
                                {{ i18n.novy_klub_sz_pri_skole }}
                            </div>
                        </div>
                        <div class="form-input">
                            <label class="form-input-label">{{ i18n.nazov }}</label>
                            <input type="text"
                                   class="form-input-element"
                                   :class="{'invalid-form-input-element': validationErrors && validationErrors['club.name']}"
                                   :placeholder="i18n.originalny_nazov_description"
                                   v-model="club.name">
                            <small class="invalid-form-input-message" v-if="validationErrors">{{
                                    validationErrors['club.name'] ? validationErrors['club.name'][0] : ''
                                }}</small>
                        </div>
                        <div class="form-input">
                            <label class="form-input-label">{{ i18n.postu_posielat_na_adresu_text }}</label>
                            <select class="form-input-element form-input-element-select" v-model="club.post_type">
                                <option :value="item.id" v-for="(item, index) in post_types">{{ item.name[lang] }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="column is-half">
                        <div class="form-header">
                            <div class="form-header-caption">
                                {{ i18n.veduci_klubu_sz }}
                            </div>
                        </div>
                        <div class="form-input">
                            <label class="form-input-label">{{ i18n.meno_a_priezvisko }}</label>
                            <input type="text" class="form-input-element" :placeholder="i18n.meno_a_priezvisko"
                                   v-model="teacher.name"
                                   :class="{'invalid-form-input-element': validationErrors && validationErrors['teacher.name']}">
                            <small class="invalid-form-input-message" v-if="validationErrors">{{
                                    validationErrors['teacher.name'] ? validationErrors['teacher.name'][0] : ''
                                }}</small>
                        </div>
                        <div class="form-input">
                            <label class="form-input-label">{{ i18n.titul }}</label>
                            <input type="text" class="form-input-element" :placeholder="i18n.titul" v-model="teacher.title">
                        </div>
                        <div class="form-input">
                            <label class="form-input-label">{{ i18n.ulica_a_cislo }}</label>
                            <input type="text" class="form-input-element" :placeholder="i18n.ulica_a_cislo"
                                   v-model="teacher.street"
                                   :class="{'invalid-form-input-element': validationErrors && validationErrors['teacher.street']}">
                            <small class="invalid-form-input-message" v-if="validationErrors">{{
                                    validationErrors['teacher.street'] ? validationErrors['teacher.street'][0] : ''
                                }}</small>
                        </div>
                        <div class="columns is-multiline">
                            <div class="column is-full is-half-desktop">
                                <div class="form-input">
                                    <label class="form-input-label">{{ i18n.psc }}</label>
                                    <input type="text" class="form-input-element" :placeholder="i18n.psc"
                                           v-model="teacher.zip"
                                           :class="{'invalid-form-input-element': validationErrors && validationErrors['teacher.zip']}">
                                    <small class="invalid-form-input-message" v-if="validationErrors">{{
                                            validationErrors['teacher.zip'] ? validationErrors['teacher.zip'][0] : ''
                                        }}</small>
                                </div>
                            </div>
                            <div class="column is-full is-half-desktop">
                                <div class="form-input">
                                    <label class="form-input-label">{{ i18n.mesto }}</label>
                                    <input type="text" class="form-input-element" :placeholder="i18n.mesto"
                                           v-model="teacher.city"
                                           :class="{'invalid-form-input-element': validationErrors && validationErrors['teacher.city']}">
                                    <small class="invalid-form-input-message" v-if="validationErrors">{{
                                            validationErrors['teacher.city'] ? validationErrors['teacher.city'][0] : ''
                                        }}</small>
                                </div>
                            </div>
                        </div>
                        <div class="columns is-multiline">
                            <div class="column is-full is-half-desktop">
                                <div class="form-input">
                                    <label class="form-input-label">{{ i18n.vas_email }} *</label>
                                    <input type="text" class="form-input-element" :placeholder="i18n.vas_email + ' *'"
                                           v-model="teacher.email"
                                           :class="{'invalid-form-input-element': validationErrors && validationErrors['teacher.email']}">
                                    <small class="invalid-form-input-message" v-if="validationErrors">{{
                                            validationErrors['teacher.email'] ? validationErrors['teacher.email'][0] : ''
                                        }}</small>
                                </div>
                            </div>
                            <div class="column is-full is-half-desktop">
                                <div class="form-input">
                                    <label class="form-input-label">{{ i18n.heslo_text }} *</label>
                                    <input type="password" class="form-input-element" :placeholder="i18n.heslo_text + ' *'"
                                           v-model="teacher.password"
                                           :class="{'invalid-form-input-element': validationErrors && validationErrors['teacher.password']}">
                                    <small class="invalid-form-input-message" v-if="validationErrors">{{
                                            validationErrors['teacher.password'] ? validationErrors['teacher.password'][0] :
                                                ''
                                        }}</small>
                                </div>
                            </div>
                        </div>
                        <div class="form-input">
                            <label class="form-input-label">{{ i18n.telefon }}</label>
                            <input type="text" class="form-input-element" :placeholder="i18n.telefon"
                                   v-model="teacher.phone"
                                   :class="{'invalid-form-input-element': validationErrors && validationErrors['teacher.phone']}">
                            <small class="invalid-form-input-message" v-if="validationErrors">{{
                                    validationErrors['teacher.phone'] ? validationErrors['teacher.phone'][0] : ''
                                }}</small>
                        </div>
                        <div class="columns is-multiline">
                            <div class="column is-full">
                                <div class="form-input mb-0">
                                    <p class="form-input-label">{{ i18n.pohlavie_text }} *</p>
                                </div>
                            </div>
                            <div class="column">
                                <div class="form-input mb-0">
                                    <input class="form-input-element-checkbox" value="M" v-model="teacher.gender"
                                           id="gender_M" type="radio">
                                    <label for="gender_M">{{ i18n.muz }}</label>
                                </div>
                            </div>
                            <div class="column">
                                <div class="form-input mb-0">
                                    <input class="form-input-element-checkbox" value="F" v-model="teacher.gender"
                                           id="gender_F" type="radio">
                                    <label for="gender_F">{{ i18n.zena }}</label>
                                </div>
                            </div>
                        </div>
                        <div class="form-input">
                            <label class="form-input-label">{{ i18n.datum_narodenia }}</label>
                            <input type="text" class="form-input-element" v-model="teacher.birthday"
                                   :class="{'invalid-form-input-element': validationErrors && validationErrors['teacher.birthday']}"
                                   :placeholder="i18n.zadavajte_v_tvare_01_01_2000">
                            <small class="invalid-form-input-message" v-if="validationErrors">{{
                                    validationErrors['teacher.birthday'] ? validationErrors['teacher.birthday'][0] : ''
                                }}</small>
                        </div>
                    </div>
                    <div class="column is-full">
                        <h3 class="h3 has-text-centered">
                            {{ i18n.zoznam_clenov_skolskeho_klubu_sz_okrem_veduceho_sz_uvedeneho_vyssie }}
                        </h3>
                        <div class="headline-delimiter is-centered mb-4"></div>
                        <p class="has-text-centered">{{ i18n.clenov_klubu_je_mozne_pridat_aj_neskor }}</p>
                        <div class="columns is-multiline">
                            <div
                                class="column is-full is-half-desktop"
                                v-for="(item, index) in students"
                                :key="index"
                            >
                                <div class="form-header">
                                    <div class="form-header-caption">{{
                                            item.name ? item.name : i18n.clen + (index
                                                + 1)
                                        }}
                                    </div>
                                </div>
                                <div class="FormWrap">
                                    <div class="text-right">
                                        <button
                                            type="button"
                                            class="button button--grey"
                                            @click="removeStudent(index)"
                                        >{{ i18n.odstranit_clena }}
                                        </button>
                                    </div>
                                    <div class="form-input">
                                        <label class="form-input-label">{{ i18n.meno_a_priezvisko }}</label>
                                        <input type="text" class="form-input-element" :placeholder="i18n.meno_a_priezvisko"
                                               v-model="item.name"
                                               :class="{'invalid-form-input-element': validationErrors && validationErrors['students.' + index + '.name']}">
                                        <small class="invalid-form-input-message" v-if="validationErrors">{{
                                                validationErrors['students.' + index + '.name'] ? validationErrors['students.' + index + '.name'][0] : ''
                                            }}</small>
                                    </div>
                                    <div class="form-input">
                                        <label class="form-input-label">{{ i18n.ulica_a_cislo }}</label>
                                        <input type="text" class="form-input-element" :placeholder="i18n.ulica_a_cislo"
                                               v-model="item.street"
                                               :class="{'invalid-form-input-element': validationErrors && validationErrors['students.' + index + '.street']}">
                                        <small class="invalid-form-input-message" v-if="validationErrors">{{
                                                validationErrors['students.' + index + '.street'] ? validationErrors['students.' + index + '.street'][0] : ''
                                            }}</small>
                                    </div>
                                    <div class="columns is-multiline">
                                        <div class="column is-full is-half-desktop">
                                            <div class="form-input">
                                                <label class="form-input-label">{{ i18n.psc }}</label>
                                                <input type="text" class="form-input-element" :placeholder="i18n.psc"
                                                       v-model="item.zip"
                                                       :class="{'invalid-form-input-element': validationErrors && validationErrors['students.' + index + '.zip']}">
                                                <small class="invalid-form-input-message" v-if="validationErrors">{{
                                                        validationErrors['students.' + index + '.zip'] ? validationErrors['students.' + index + '.zip'][0] : ''
                                                    }}</small>
                                            </div>
                                        </div>
                                        <div class="column is-full is-half-desktop">
                                            <div class="form-input">
                                                <label class="form-input-label">{{ i18n.mesto }}</label>
                                                <input type="text" class="form-input-element" :placeholder="i18n.mesto"
                                                       v-model="item.city"
                                                       :class="{'invalid-form-input-element': validationErrors && validationErrors['item.city']}">
                                                <small class="invalid-form-input-message" v-if="validationErrors">{{
                                                        validationErrors['students.' + index + '.city'] ? validationErrors['students.' + index + '.city'][0] : ''
                                                    }}</small>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-input">
                                        <label class="form-input-label">{{ i18n.pohlavie_text }} *</label>
                                        <label for>
                                            <input type="radio" v-model="item.gender" value="M"> &nbsp; {{ i18n.muz }}
                                        </label>
                                        <label for>
                                            <input type="radio" v-model="item.gender" value="F"> &nbsp; {{ i18n.zena }}
                                        </label>
                                    </div>
                                    <div class="form-input">
                                        <label class="form-input-label">{{ i18n.datum_narodenia }}</label>
                                        <input type="text" class="form-input-element"
                                               :placeholder="i18n.zadavajte_v_tvare_01_01_2000"
                                               v-model="item.birthday"
                                               :class="{'invalid-form-input-element': validationErrors && validationErrors['students.' + index + '.birthday']}">
                                        <small class="invalid-form-input-message" v-if="validationErrors">{{
                                                validationErrors['students.' + index + '.birthday'] ? validationErrors['students.' + index + '.birthday'][0] : ''
                                            }}</small>
                                    </div>
                                    <div class="form-input">
                                        <label class="form-input-label">{{ i18n.meno_a_priezvisko_rodica_text }} *</label>
                                        <input type="text" class="form-input-element"
                                               :placeholder="i18n.meno_a_priezvisko_rodica_text + ' *'"
                                               v-model="item.parent_name"
                                               :class="{'invalid-form-input-element': validationErrors && validationErrors['students.' + index + '.parent_name']}">
                                        <small class="invalid-form-input-message" v-if="validationErrors">{{
                                                validationErrors['students.' + index + '.parent_name'] ? validationErrors['students.' + index + '.parent_name'][0] : ''
                                            }}</small>
                                    </div>
                                    <div class="columns is-multiline">
                                        <div class="column is-full is-half-desktop">
                                            <div class="form-input">
                                                <label class="form-input-label">{{ i18n.email_rodica_text }}</label>
                                                <input type="text" class="form-input-element"
                                                       :placeholder="i18n.email_rodica_text"
                                                       v-model="item.parent_email"
                                                       :class="{'invalid-form-input-element': validationErrors && validationErrors['students.' + index + '.parent_email']}">
                                                <small class="invalid-form-input-message" v-if="validationErrors">{{
                                                        validationErrors['students.' + index + '.parent_email'] ? validationErrors['students.' + index + '.parent_email'][0] : ''
                                                    }}</small>
                                            </div>
                                        </div>
                                        <div class="column is-full is-half-desktop">
                                            <div class="form-input">
                                                <label class="form-input-label">{{ i18n.telefon_na_rodica }}</label>
                                                <input type="text" class="form-input-element"
                                                       :placeholder="i18n.telefon_na_rodica"
                                                       v-model="item.parent_phone"
                                                       :class="{'invalid-form-input-element': validationErrors && validationErrors['students.' + index + '.parent_phone']}">
                                                <small class="invalid-form-input-message" v-if="validationErrors">{{
                                                        validationErrors['students.' + index + '.parent_phone'] ? validationErrors['students.' + index + '.parent_phone'][0] : ''
                                                    }}</small>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="column is-full">
                        <div class="SubmitButton text-center">
                            <button type="button" class="button button--blue" @click="addStudent()">{{ i18n.pridat_clena }}
                            </button>
                            <p class="m-t-b-20">- {{ i18n.alebo }} -</p>
                            <vue-xlsx-table @on-select-file="handleSelectedFile">{{ i18n.nahrat_formular }}</vue-xlsx-table>
                            <a href="/documents/formular_pre_import.xlsx" target="_blank" class="orange-link">{{ i18n.formular_pre_import }}</a>
                            <p class="m-t-5"><small>{{ i18n.v_stiahnutom_subore_nevymazavajte_hlavicku_nachadzajucu_sa_v_prvom_riadku }}<br>{{ i18n.po_uspesnom_importe_sa_vam_deti_zobrazia_automaticky_v_zozname_clenov }}</small>
                            </p>
                        </div>
                    </div>
                    <div class="column is-full">
                        <div class="SubmitButton text-center">
                            <button type="button" class="button " @click="register()">{{ i18n.odoslat_udaje }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {sk} from 'vuejs-datepicker/dist/locale'

export default {
    components: {
        Datepicker
    },
    mounted() {
        // this.get_city_by_id(1191);
    },
    props: {
        school: Object,
        cities: Array,
        districts: Object,
        post_types: Array,
        storeSchoolClubRoute: String
    },
    data: function () {
        return {
            sk: sk,
            club: {
                name: null,
                post_type: 1
            },
            teacher: {
                name: null,
                title: null,
                street: null,
                zip: null,
                city: null,
                birthday: null,
                gender: "M",
                email: null,
                password: null,
                phone: null
            },
            students: [],
            validationErrors: null,
            schoolFilled: false,
            registered: false,
            lang: document.documentElement.lang,
            i18n: i18n
        };
    },
    methods: {
        handleSelectedFile(convertedData) {
            convertedData.body.map((row, index) => {
                this.students.push({
                    name: row['MENO_DIETATA'] + ' ' + row['PRIEZVISKO_DIETATA'],
                    birthday: row['DEN_NARODENIA'] + '.' + (row['MESIAC_NARODENIA']) + '.' + row['ROK_NARODENIA'],
                    gender: row['POHLAVIE'] == 'm' ? 'M' : 'F',
                    street: row['ULICA'] + ' ' + row['CISLO_DOMU'],
                    zip: row['PSC'],
                    city: row['MESTO'],
                    agree_parent: false,
                    email: null,
                    password: null,
                    parent_name: row['MENO_PRIEZVISKO_RODICA'],
                    parent_email: row['EMAIL_RODICA'],
                    parent_phone: row['TELEFON_RODICA']
                });
            })
        },
        get_city_by_id(id) {
            let city = this.cities.filter(item => {
                if (item.id == id) {
                    return item;
                }
            });

            return city[0];
        },
        get_district_by_id(id) {
            let district = this.districts.filter(item => {
                if (item.id == id) {
                    return item;
                }
            });

            return district[0];
        },
        register() {
            axios
                .post(this.storeSchoolClubRoute, {
                    school: this.school,
                    teacher: this.teacher,
                    students: this.students,
                    club: this.club
                })
                .then(response => {
                    this.registered = true;
                })
                .catch(error => {
                    this.registered = false;
                    if (error.response.status == 422) {
                        this.validationErrors = error.response.data.errors;
                    }
                })
                .then(() => {
                    document.getElementById("SchoolClubRegistration").scrollIntoView();
                    window.scrollBy(0, -75);
                });
        },
        addStudent() {
            this.students.push({
                name: null,
                birthday: null,
                gender: "M",
                street: null,
                zip: this.school.zip,
                city: this.school.city,
                agree_parent: false,
                email: null,
                password: null,
                parent_name: null,
                parent_email: null,
                parent_phone: null
            });
        },
        removeStudent(index) {
            if (confirm('Ste si istí?'))
                this.$delete(this.students, index);
        }
    }
};
</script>

<style lang="scss">
.xlsx-button {
    border: 0;
    display: inline-block;
    border-radius: 30px;
    padding: 15px;
    line-height: 0;
    text-align: center;
    background-color: #f6f4f5;
    color: #999998;
    font-size: 12px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;

    &:hover {
        color: #4a4a4a;
    }
}
</style>
